import Joi from '@hapi/joi'

export const WorkedInactiveEmployeeSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group is required`,
        "any.required": `Group is required`,
        "number.base": `Group is required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Operation Entity is required`,
        "any.required": `Operation Entity is required`,
        "number.base": `Operation Entity is required`
    }),
    divisionID: Joi.number().label("Division").messages({
        "number.base": `Collection Point must be a number`
    }),
    fromDate: Joi.string().required().label("From Date").messages({
        "string.empty": `From Date is required`,
        "any.required": `From Date is required`
    }),
    toDate: Joi.string().required().label("To Date").messages({
        "string.empty": `To Date is required`,
        "any.required": `To Date is required`
    })
}